import { fetchEnterpriseSettingsByEnterpriseUuid, fetchDefaultSettings, fetchScopeSettings } from '@/service/api/enterprise.api';

const backendOrigin = new URL(process.env.VUE_APP_CORE_HOST).origin;
const logoBaseUrl = `${backendOrigin}/logo/company-settings`;

const state = {
    settingsEnterpriseUuid: null,
    defaultSettings: {},
    currentSettings: {},
    defaultSidebarColor: '#1D4880',
};

const mutations = {
    'SET_SETTINGS_ENTERPRISE_UUID'(state, uuid) {
        state.settingsEnterpriseUuid = uuid;
    },
    'SET_DEFAULT_SETTINGS'(state, settings) {
        state.defaultSettings = settings;
        if (!state.settingsEnterpriseUuid) {
            state.currentSettings = settings;
        }
    },
    'SET_SETTINGS'(state, settings) {
        state.currentSettings = settings;
    },
    'CLEAR_SETTINGS'(state) {
        state.currentSettings = state.defaultSettings;
        window.localStorage.removeItem('currentSettings');
    },
};

const actions = {
    async loadDefaultSettings({ commit }) {
        const { data } = await fetchDefaultSettings();
        commit('SET_DEFAULT_SETTINGS', data);
    },
    async setSettingsContext({ commit, state }, { enterpriseUuid, isPublic = false }) {
        if (!enterpriseUuid || enterpriseUuid === state.settingsEnterpriseUuid) {
            return;
        }

        commit('SET_SETTINGS_ENTERPRISE_UUID', enterpriseUuid);
        const { data } = await fetchEnterpriseSettingsByEnterpriseUuid(enterpriseUuid, isPublic);
        commit('SET_SETTINGS', data);
    },
    async loadScopeSettings({ commit, rootGetters }) {
        // Avoid overriding enterprise level settings with tdc1 / tdc2 settings.
        if (rootGetters.enterpriseUuid) {
            return;
        }

        const { data } = await fetchScopeSettings();
        commit('SET_SETTINGS', data);
    },
    clearSettings({ commit }) {
        commit('SET_SETTINGS_ENTERPRISE_UUID', null);
        commit('CLEAR_SETTINGS');
    },
};

const getters = {
    enterpriseSettingsUuid: state => state.settingsEnterpriseUuid,
    enterpriseSettings: state => state.currentSettings,
    sidebarColor: (state) => {
        return state.currentSettings?.primaryColor || state.defaultSidebarColor;
    },
    logoUrl: (state) => {
        const logo = state.currentSettings?.logo;

        return logo ? `${logoBaseUrl}/${logo}` : null;
    },
    miniLogoUrl: (state) => {
        const miniLogo = state.currentSettings?.miniLogo;

        return miniLogo ? `${logoBaseUrl}/${miniLogo}` : null;
    },
};

export default { state, mutations, actions, getters };
